import React, { useState } from 'react'

import { Drawer, Modal, useDisclosure } from '@chakra-ui/react'

import { IcfDocumentListRenewal } from './list-renewal'
import { useIcfDocumentList } from './list.hooks'
import { ReAgreementConfirmModalRenewal } from '../components/re-agreement-confirm-modal-renewal'
import { IcfDocumentDetailContainer } from '../detail/detail-container'
import { IcfDocumentReAgreementConfirmRenewal } from '../re-agreement-confirm/re-agreement-confirm-renewal'
import { useIcfDocumentReAgreementConfirm } from '../re-agreement-confirm/re-agreement-confirm.hooks'

export const IcfDocumentListContainer: React.FC<{}> = () => {
  const {
    icfDocumentList,
    selectedTrialHospitalUid,
    shouldShowReAgreementConfirmButton,
    navigateToAdd,
    navigateToEdit,
  } = useIcfDocumentList()

  const {
    isRequiredReAgreementConfirmDocuments,
    selectedDocUids,
    selectedDocuments,
    handleToggle,
    handleConfirm,
    handleCloseModal,
    handleSubmit,
  } = useIcfDocumentReAgreementConfirm(icfDocumentList)

  const [documentUid, setDocumentUid] = useState('')

  const {
    isOpen: isOpenDetail,
    onOpen: onOpenDetail,
    onClose: onCloseDetail,
  } = useDisclosure()

  const {
    isOpen: isOpenReAgreementSelect,
    onOpen: onOpenReAgreementSelect,
    onClose: onCloseReAgreementSelect,
  } = useDisclosure()

  const {
    isOpen: isOpenReAgreementConfirm,
    onOpen: onOpenReAgreementConfirm,
    onClose: onCloseReAgreementConfirm,
  } = useDisclosure()

  const handleClickDocumentSetLink = (documentUid: string) => {
    setDocumentUid(documentUid)
    onOpenDetail()
  }

  return (
    <>
      <IcfDocumentListRenewal
        icfDocumentList={icfDocumentList ?? []}
        selectedTrialHospitalUid={selectedTrialHospitalUid}
        shouldShowReAgreementConfirmButton={shouldShowReAgreementConfirmButton}
        navigateToAdd={navigateToAdd}
        navigateToEdit={navigateToEdit}
        onClickDocumentSetLink={handleClickDocumentSetLink}
        onClickReAgreementConfirmButton={onOpenReAgreementSelect}
      />
      <Drawer isOpen={isOpenDetail} onClose={onCloseDetail}>
        <IcfDocumentDetailContainer documentUid={documentUid} />
      </Drawer>
      <Modal
        isOpen={isOpenReAgreementSelect}
        onClose={onCloseReAgreementSelect}
        size="4xl"
      >
        <IcfDocumentReAgreementConfirmRenewal
          isRequiredReAgreementConfirmDocuments={
            isRequiredReAgreementConfirmDocuments
          }
          selectedDocUids={selectedDocUids}
          onToggle={handleToggle}
          onClose={onCloseReAgreementSelect}
          onConfirm={() => {
            handleConfirm()
            onCloseReAgreementSelect()
            onOpenReAgreementConfirm()
          }}
        />
      </Modal>
      <Modal
        isOpen={isOpenReAgreementConfirm}
        onClose={onCloseReAgreementConfirm}
        size="xl"
      >
        <ReAgreementConfirmModalRenewal
          docs={selectedDocuments}
          onClose={handleCloseModal}
          onSubmit={async () => {
            await handleSubmit()
            onCloseReAgreementConfirm()
          }}
        />
      </Modal>
    </>
  )
}
